var _excluded = ["width", "isFullWidth", "isFullWidthOnMobile", "negativeMargins", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { StyledContainerOrg } from "./ContainerOrg.styles";
export var sizesSpace = {
  tiny: 56,
  // 448px
  small: 92,
  // 736px
  medium: 117,
  // 936px
  "default": 160 // 1280px
};
export var defaultProps = {
  width: "default",
  isFullWidth: false,
  isFullWidthOnMobile: false,
  negativeMargins: {
    top: "sticky",
    bottom: "sticky"
  }
};
function ContainerOrg(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? defaultProps.width : _ref$width,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? defaultProps.isFullWidth : _ref$isFullWidth,
    _ref$isFullWidthOnMob = _ref.isFullWidthOnMobile,
    isFullWidthOnMobile = _ref$isFullWidthOnMob === void 0 ? defaultProps.isFullWidthOnMobile : _ref$isFullWidthOnMob,
    _ref$negativeMargins = _ref.negativeMargins,
    negativeMargins = _ref$negativeMargins === void 0 ? defaultProps.negativeMargins : _ref$negativeMargins,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledContainerOrg, _extends({
    $width: width,
    $isFullWidth: isFullWidth,
    $isFullWidthOnMobile: isFullWidthOnMobile,
    $negativeMargins: negativeMargins
  }, restProps), children);
}
export default ContainerOrg;